import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-inner">
        <Link to="/" className="navbar-logo">
          <span className="logo-remax-text">RE/MAX</span>
          <span className="logo-vantagem-text">Grupo Vantagem</span>
        </Link>

        <button
          className={`hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <span /><span /><span />
        </button>

        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link to="/" className={location.pathname === '/' ? 'active' : ''}>Início</Link>
          <Link to="/imoveis" className={location.pathname.startsWith('/imoveis') ? 'active' : ''}>Imóveis</Link>
          <Link to="/vender" className={location.pathname === '/vender' ? 'active' : ''}>Quero Vender</Link>
          <Link to="/viabilidade-de-credito" className={location.pathname === '/viabilidade-de-credito' ? 'active' : ''}>Viabilidade</Link>
          <Link to="/blog" className={location.pathname.startsWith('/blog') ? 'active' : ''}>Blog</Link>
          <Link to="/referencias" className={`btn-referencias ${location.pathname === '/referencias' ? 'active' : ''}`}>
            🤝 Ganha 300€
          </Link>
          <Link to="/cartao" className="btn-cartao">Cartão Digital</Link>
        </div>
      </div>
    </nav>
  );
}
